export default "__VITE_ASSET__BR$d8Vzn__"